var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulseLineSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3F70ED",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 31.746 31.746",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.614,25.866c-0.557,0-1.039-0.248-1.152-0.793L8.901,17.6l-1.028,1.774c-0.211,0.359-0.597,0.613-1.012,0.613H1.176 C0.527,19.987,0,19.46,0,18.813c0-0.65,0.527-1.178,1.176-1.178h5.013l2.235-3.777c0.247-0.417,0.721-0.644,1.205-0.562 c0.479,0.08,0.86,0.446,0.958,0.921l0.945,4.566l2.155-11.956c0.101-0.56,0.588-0.949,1.158-0.949c0.001,0,0.004,0,0.005,0 c0.571,0,1.058,0.396,1.154,0.958l2.3,13.421l0.74-1.875c0.176-0.45,0.61-0.749,1.093-0.749H30.57 c0.649,0,1.176,0.526,1.176,1.177c0,0.648-0.526,1.176-1.176,1.176h-9.635l-1.99,5.029c-0.192,0.49-0.682,0.787-1.215,0.737 c-0.522-0.056-0.947-0.452-1.037-0.972l-1.876-10.965l-2.046,11.225c-0.1,0.555-0.579,0.824-1.142,0.824 C11.624,25.866,11.619,25.866,11.614,25.866z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseLineSvg);
export default __webpack_public_path__ + "static/media/pulse-line-svg.0030507bdb2d6c267f18d331e063a9f5.svg";
export { ForwardRef as ReactComponent };